import React, { useEffect, useRef, useState } from "react";
import "./TopNav.css";
import {
  Menu,
  MessageSquareDot,
  Settings,
  FileText,
  Search,
  User,    // Add this
  Mail,    // Add this
  Phone,   // Add this
  Shield,  // Add this
  Info
} from "lucide-react";
import { empLogout } from "../redux/api/admin/authApi";
import { Avatar, Wrap, WrapItem } from "@chakra-ui/react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Box,
  Text,
  Divider,
  ModalCloseButton,
  VStack,  // Add this
  HStack,  // Add this (if using)
  Badge,
} from "@chakra-ui/react";
// import Flex from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react'; // ✅ This is correct

import Searchbar from "./Searchbar";
import GlobalSearch from "../pages/AdminPannel/globalSearch/GlobalSearch";
import { FaSignOutAlt } from "react-icons/fa";
import { clearAdminAuth } from "../pages/AdminPannel/utils/adminAuth";
import { clearPermissions, getPermissions, getUserId } from "../../utils/IndexDB/PermissionStore";

function Navbar(props) {
  const navigate = useNavigate();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedModule, setSelectedModule] = useState("All Modules");
  const setting = useRef(null);
  const [permissions, setPermissions] = useState([]);

  const [resultFound, setResultfound] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  // const user = {
  //   name: "Saumya",
  //   email: "saumya.123@example.com",
  //   role: "Administrator",
  //   phone: "1234567890",
  //   empId: "ABC-123",
  //   avatarUrl: "https://bit.ly/broken-link",
  // };

  const openDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);

  const togglePopup = () => {
    console.log(setting.current);
    setting.current.classList.toggle("d-none");
  };
  useEffect(() => {
    const handleClickOutSide = (e) => {
      if (setting.current && !setting.current.contains(e.target)) {
        setting.current.classList.add("d-none");
      }
    };

    document.addEventListener("mousedown", handleClickOutSide);
    return () => {
      document.removeEventListener("mousedown", handleClickOutSide);
    };
  }, []);

  useEffect(() => {
    (async () => {
      const userId = await getUserId();
      if (!userId) return;

      const permissionRes = await getPermissions(userId);
      setPermissions(permissionRes);
    })();
  }, []);

  const openTrash = () => {
    setIsOpen(true);
  };
  const closeTrash = () => {
    setIsOpen(false);
    setIsSearch(false);
  };

  const user = JSON.parse(localStorage.getItem("adminUser"))

  const handelLogout = async () => {
    localStorage.clear();
    clearPermissions()
    navigate("/admin-login");
    // handleOptionClick();
    clearAdminAuth();
    empLogout();
  };

  const normalize = (name) => {
    return name?.toLowerCase().replace(/\s+/g, "").trim();
  };

  const hasPermission = (moduleName) => {
    const found = permissions.find(
      (p) => normalize(p.moduleName) === normalize(moduleName)
    );

    return found?.viewOnly || found?.viewAll;
  };

  const canShowSettings =
    hasPermission("organisation profile") ||
    hasPermission("roles") ||
    hasPermission("column formulation") ||
    hasPermission("zip code master") ||
    hasPermission("terms and condition") ||
    hasPermission("warehouse") ||
    hasPermission("colour") ||
    hasPermission("customer credit") ||
    hasPermission("motorization") ||
    hasPermission("volumetric") ||
    hasPermission("material collection");

  return (
    <>
      <nav className="navbar " >
        <div className="nav-main-div">
          <button onClick={props.collapseSidenav} className="px-1">
            <Menu />
          </button>
          <ul>

            {/* <li>
              <button onClick={() => navigate("organisation-settings")} className="p-2 rounded-full hover:cursor-pointer">
                <Settings />
              </button>

            </li> */}
            {canShowSettings && (
              <li>
                <button
                  onClick={() => navigate("organisation-settings")}
                  className="p-2 rounded-full hover:cursor-pointer"
                >
                  <Settings />
                </button>
              </li>
             )} 

            <li>
              <button onClick={openDrawer} className="p-2 rounded-full hover:cursor-pointer">
                <Avatar size="sm" name={user?.employeeName} src={user?.avatarUrl} />
              </button>

            </li>

            <li className="position-relative">
              <Wrap>

                {/* <WrapItem>
                  <Avatar
                    onClick={togglePopup}
                    size="sm"
                    name="Kola Tioluwani"
                    src="https://bit.ly/tioluwani-kolawole"
                  />{" "}
                </WrapItem> */}
              </Wrap>
              {/* <div ref={setting} className={`popup-div d-none px-0`}>
                <div className="border-bottom w-100 mb-2">
                  <h5 className="mx-3">Profile</h5>
                </div>
                <div className="border-bottom w-100 list-div mb-2">
                  <Link to="/user-role">
                    <p className="mb-0 me-2 ms-3">Roles</p>
                  </Link>
                  <Link className="flex items-center  ">
                    <FaSignOutAlt className="mr-2 text-sm" />
                    Log out
                  </Link> 
                </div>
              </div> */}
            </li>
          </ul>
        </div>
        <Modal isOpen={isOpen} onClose={closeTrash} placement="top" size="xl">
          <ModalContent style={{ marginTop: "0px" }}>
            <ModalBody>
              <Searchbar
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                selectedModule={selectedModule}
                setSelectedModule={setSelectedModule}
                resultFound={resultFound}
                setIsSearch={setIsSearch}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      </nav>

      <Drawer isOpen={isDrawerOpen} placement="right" onClose={closeDrawer} size="xs">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton
            size="sm"
            top={3}
            right={3}
            borderRadius="full"
            bg="white"
            boxShadow="sm"
            _hover={{ bg: "gray.100" }}
          />

          <DrawerHeader
            borderBottomWidth="1px"
            py={3}
            px={4}
            bg="linear-gradient(135deg, #f6f9fc 0%, #f0f4f8 100%)"
            className="h-14"
          >
            <Box display="flex" alignItems="center" gap={2}>

              <Box>
                <Text
                  fontSize="md"
                  fontWeight="700"
                  color="gray.800"
                  letterSpacing="-0.3px"
                  className="tracking-tight"
                >
                  Admin Profile
                </Text>
              </Box>
            </Box>
          </DrawerHeader>

          <DrawerBody py={4} px={4}>
            {/* Profile Header */}
            <Box
              textAlign="center"
              mb={5}
              pb={4}
              borderBottom="1px solid"
              borderColor="gray.100"
            >
              {/* Avatar Container */}
              <Box position="relative" display="inline-block" mb={3}>
                <Avatar
                  size="lg"
                  name={user?.employeeName}
                  src={user?.avatarUrl}
                  boxShadow="0 2px 8px rgba(0,0,0,0.08)"
                  border="3px solid white"
                  bgGradient="linear(to-br, blue.100, purple.100)"
                />
                {/* Online Indicator */}
                <Box
                  position="absolute"
                  bottom="2px"
                  right="2px"
                  width="10px"
                  height="10px"
                  bg="green.400"
                  border="2px solid white"
                  borderRadius="full"
                  boxShadow="sm"
                />
              </Box>

              {/* Name & Role */}
              <VStack spacing={0.5}>
                <Text
                  fontWeight="700"
                  fontSize="sm"
                  color="gray.800"
                  className="truncate max-w-[180px] !mb-0"
                >
                  {user?.employeeName}
                </Text>
                <Badge
                  colorScheme="blue"
                  variant="subtle"
                  fontSize="xs"
                  fontWeight="600"
                  px={2}
                  py={0.5}
                  borderRadius="full"
                >
                  {user?.role || "Administrator"}
                </Badge>
              </VStack>
            </Box>

            {/* Info Cards - More Compact */}
            <Box borderRadius="lg" overflow="hidden" borderColor="gray.200">
              {/* Email */}
              <Flex
                align="center"
                px={3.5}
                py={3.5}
                h="44px"
                borderBottom="1px solid"
                borderColor="gray.100"
                bg="white"
                _hover={{ bg: "blue.50" }}
                transition="background 0.2s"
              >
                <Box
                  w={7}
                  h={7}
                  mr={2.5}
                  bg="blue.50"
                  color="blue.600"
                  borderRadius="md"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexShrink={0}
                >
                  <Mail size={14} />
                </Box>
                <Box flex={1} minW={0}>
                  <Text
                    fontSize="2xs"
                    fontWeight="700"
                    color="gray.600"
                    mb="1px"
                    className="uppercase tracking-tight"
                  >
                    Email
                  </Text>
                  <Text
                    fontSize="xs"
                    color="gray.800"
                    fontWeight="500"
                    noOfLines={1}
                    className="truncate"
                    lineHeight="1.1"
                  >
                    {user?.email}
                  </Text>
                </Box>
              </Flex>

              {/* Phone - Updated to match Email */}
              <Flex
                align="center"
                px={3.5}
                py={3.5}
                mt={3}
                h="45px"  // Changed from h="58px" to match Email
                borderBottom="1px solid"
                borderColor="gray.100"
                bg="white"
                alignItems="center"
                justifyContent="center"
                _hover={{ bg: "green.50" }}
                transition="background 0.2s"
              >
                <Box
                  w={7}
                  h={7}
                  mr={2.5}
                  bg="green.50"
                  color="green.600"
                  borderRadius="md"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexShrink={0}
                >
                  <Phone size={14} />  {/* Changed from size={16} to match Mail */}
                </Box>
                <Box flex={1} minW={0}>
                  <Text
                    fontSize="2xs"
                    fontWeight="700"
                    color="gray.600"
                    mb="1px"  // Changed from mb={0.5} to match Email
                    className="uppercase tracking-tight"
                  >
                    Phone
                  </Text>
                  <Text
                    fontSize="xs"  // Changed from sm to xs to match Email
                    color="gray.800"
                    fontWeight="500"
                    noOfLines={1}  // Added to match Email
                    className="truncate"  // Added to match Email
                    lineHeight="1.1"  // Added to match Email
                  >
                    {user?.phoneNumber || "Not provided"}
                  </Text>
                </Box>
              </Flex>

              {/* Role - Updated to match Email */}
              <Flex
                align="center"
                px={3.5}
                py={3.5}
                mt={3}
                h="45px"  // Changed from h="55px" to match Email
                bg="white"
                _hover={{ bg: "purple.50" }}
                transition="background 0.2s"
              >
                <Box
                  w={7}
                  h={7}
                  mr={2.5}

                  bg="purple.50"
                  color="purple.600"
                  borderRadius="md"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexShrink={0}
                >
                  <Shield size={14} />  {/* Already size={14} to match Mail */}
                </Box>
                <Box flex={1} minW={0}>
                  <Text
                    fontSize="2xs"
                    fontWeight="700"
                    color="gray.600"
                    mb="1px"  // Changed from mb={0.5} to match Email
                    className="uppercase tracking-tight"
                  >
                    Role
                  </Text>
                  <Text
                    fontSize="xs"  // Changed from sm to xs to match Email
                    color="gray.800"
                    fontWeight="500"
                    noOfLines={1}  // Added to match Email
                    className="truncate"  // Added to match Email
                    lineHeight="1.1"  // Added to match Email
                  >
                    {user?.rolesName || "Administrator"}
                  </Text>
                </Box>
              </Flex>
            </Box>
          </DrawerBody>

          <DrawerFooter>
            <Button leftIcon={<FaSignOutAlt />} colorScheme="green" w="full" onClick={handelLogout}  >
              Log Out</Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
      {isSearch && (
        <GlobalSearch
          searchTerm={searchTerm}
          selectedModule={selectedModule}
          setResultfound={setResultfound}
          resultFound={resultFound}
        />
      )}
    </>
  );
}
export default Navbar;
